import { FC } from 'react';
import { AdditionalLink } from './AdditionalLink';
import { LOGIN_REGISTER_LINK, LOGIN_REGISTER_TITLE } from '../../../constants/data';
import { Link } from '@bpba/ui-components';

export const AdditionalLinksContainer: FC = () => {
  const registerLink = new Link(
    LOGIN_REGISTER_LINK.ruta,
    LOGIN_REGISTER_LINK.isExterno,
    LOGIN_REGISTER_LINK.abreSolapa,
    LOGIN_REGISTER_LINK.tag
  );

  return (
    <>
      <AdditionalLink title={LOGIN_REGISTER_TITLE} link={registerLink} />
    </>
  );
};
